import $ from "jquery";
import moment from "moment";
import React, { Component } from "react";
import "react-datepicker/dist/react-datepicker.css";
import { Redirect } from "react-router-dom";
import Comm from "../comm/comm";
import Context from "../context/context";
import Edit from "../controls/edit";
import PackinglistData from "../controls/packinglistdata";
import Translation from "../translation/translation";

class Invoices extends Component {
    PackingListsPageSize = 10;
    DoBind() {
        this.ChangePage = this.ChangePage.bind(this);
        this.PrintElem = this.PrintElem.bind(this);
        this.PackingLists = this.PackingLists.bind(this);
        this.ChangePartner = this.ChangePartner.bind(this);
        this.RotateColumns = this.RotateColumns.bind(this);
        this.ShowPackingList = this.ShowPackingList.bind(this);
        this.ShowSubPage = this.ShowSubPage.bind(this);
        this.ChangeReceiver = this.ChangeReceiver.bind(this);
        this.ChangeTransport = this.ChangeTransport.bind(this);
        this.CopyAddressFromBuyer = this.CopyAddressFromBuyer.bind(this);
        this.EditRow = this.EditRow.bind(this);
        this.SaveRow = this.SaveRow.bind(this);
        this.CancelRow = this.CancelRow.bind(this);
        this.DelRow = this.DelRow.bind(this);
        this.RecalcTotal = this.RecalcTotal.bind(this);
        this.DisplayTotals = this.DisplayTotals.bind(this);
        this.PrintInvoice = this.PrintInvoice.bind(this);
        this.ShowPackingListReport = this.ShowPackingListReport.bind(this);
        this.SaveInvoiceData = this.SaveInvoiceData.bind(this);
        this.DeletePackingList = this.DeletePackingList.bind(this);
    }

    constructor(props) {
        super(props);
        if (!Comm.ValidSession()) return;

        this.DoBind();

        if (!Context.IsLogged()) {
            return;
        }
        var sid = Context.GetContext().Sid;

        var partners = Comm.Partners(sid);
        var buyers = partners.slice();
        var all = {
            id: -1,
            name: Translation.Trans("all"),
        };
        partners.splice(0, 0, all);
        all = {
            id: null,
            name: "",
        };
        buyers.splice(0, 0, all);
        var packinglists = this.PackingLists(0);

        var bankaccounts = Comm.Accounts(sid);
        var accounts = [];
        for (var i = 0; i < bankaccounts.length; i++) {
            accounts.push(
                Translation.Trans("banklatin") +
                    ": " +
                    bankaccounts[i].bank +
                    " " +
                    Translation.Trans("iban") +
                    ": " +
                    bankaccounts[i].iban +
                    " " +
                    Translation.Trans("bic") +
                    ": " +
                    bankaccounts[i].bic
            );
        }

        this.transportprice = React.createRef();
        this.vatvalue = React.createRef();

        this.state = {
            PageName: "packinglists",
            InvData: {},
            Partners: partners,
            PackingLists: packinglists,
            PackingListsPage: 0,
            Buyers: buyers,
            Receivers: [],
            Accounts: accounts,
            Rows: [],
            TotalCount: 0,
            WithoutTransport: 0,
            Beforevat: 0,
            Aftervat: 0,
            ConditionsOfDelivery: [],
            PaymentConditions: [],
            PlacesOfShipment: [],
        };
    }

    componentDidMount() {
        // componentDidMount is called by react when the component
        // has been rendered on the page. We can set the interval here:

        this.timer = setInterval(this.DisplayTotals, 500);
    }

    componentWillUnmount() {
        // This method is called immediately before the component is removed
        // from the page and destroyed. We can clear the interval here:

        clearInterval(this.timer);
    }

    ChangePage(inc) {
        var page = this.state.PackingListsPage + inc;
        var pl = this.PackingLists(page);
        this.setState({
            PackingLists: pl,
            PackingListsPage: page,
        });
    }

    PackingLists(page) {
        var sid = Context.GetContext().Sid;
        var partnerId = $("#ddlPartner").val();

        var data = { session: sid, page: page, pagesize: this.PackingListsPageSize };
        if (partnerId !== "-1") data.partner = partnerId;
        var packingLists = Comm.CallServerFunction("invoices/packing_lists_for_invoicing", data);
        return packingLists;
    }

    ChangePartner() {
        var pl = this.PackingLists(0);
        this.setState({
            PackingLists: pl,
            PackingListsPage: 0,
        });
    }

    ChangeBuyer(e) {
        if (!e.target.value) {
            this.setState({ Buyer: null, Receivers: [] });
            return;
        }

        var obj = JSON.parse(e.target.value);
        var sid = Context.GetContext().Sid;

        var receivers = Comm.Receivers({
            session: sid,
            partner: obj.id,
        });
        var all = {
            id: null,
            name: "",
        };

        receivers.splice(0, 0, all);

        var conditionsOfDelivery = Comm.ConditionsOfDelivery({
            session: sid,
            partner: obj.id,
        });
        var paymentConditions = Comm.PaymentConditions({
            session: sid,
            partner: obj.id,
        });
        var placesOfShipment = Comm.PlacesOfShipment({
            session: sid,
            partner: obj.id,
        });
        this.setState({
            Buyer: obj,
            ConditionsOfDelivery: conditionsOfDelivery.data,
            PaymentConditions: paymentConditions.data,
            PlacesOfShipment: placesOfShipment.data,
            Receivers: receivers,
        });
        var txt =
            (obj.invoice_name || "") +
            "\n" +
            (obj.invoice_country || "") +
            "\n" +
            (obj.invoice_addr_line_1 || "") +
            "\n" +
            (obj.invoice_addr_line_2 || "") +
            "\n";
        this.refs.buyerimporter.SetValue(txt);
        this.refs.destination.SetValue(obj.invoice_addr_line_2 || "");
    }
    CopyAddressFromBuyer() {
        var obj = this.state.Buyer;
        if (obj === null) return;
        var txt =
            (obj.invoice_name || "") +
            "\n" +
            (obj.invoice_country || "") +
            "\n" +
            (obj.invoice_addr_line_1 || "") +
            "\n" +
            (obj.invoice_addr_line_2 || "") +
            "\n";
        this.refs.receiver.SetValue(txt);
    }

    ChangeReceiver(e) {
        if (!e.target.value) {
            return;
        }

        var obj = JSON.parse(e.target.value);
        var txt =
            (obj.name || "") +
            "\n" +
            (obj.country || "") +
            "\n" +
            (obj.addr_line_1 || "") +
            "\n" +
            (obj.addr_line_2 || "") +
            "\n";
        this.refs.receiver.SetValue(txt);
    }

    ChangeTransport(e) {
        this.setState({ TransportId: e.target.value });
        switch (parseInt(e.target.value, 10)) {
            case 1:
                this.refs.meansoftransport.SetValue("Cont. No : ");
                break;
            case 2:
                this.refs.meansoftransport.SetValue("Truck reg No : \n Trailer No : ");
                break;
            default:
                break;
        }
    }

    DeletePackingList(id) {
        var sid = Context.GetContext().Sid;

        Comm.DeletePackingList({ session: sid, id: id });
        this.ChangePartner();
    }

    ShowPackingList(id, toPackingList = false) {
        var sid = Context.GetContext().Sid;

        var pl = Comm.PackingList({
            session: sid,
            id: id,
            lang: Translation.CurrentLanguage().toLowerCase(),
        });
        var html = pl.html;
        html = html.replace(/fixed/gi, "relative");
        html = html + "<nocache id='" + moment().format() + "'/>";

        var data = Comm.InvoiceData({ session: sid, packing_list: id });

        var result;
        if (toPackingList) {
            result = Comm.GetPackingListData({
                session: sid,
                id,
            });
        }
        this.InitInvoiceData(data, result);
        this.setState({
            PageName: toPackingList ? "packinglist" : "packinglistdata",
            DisplayedPackingList: id,
            PackingListHtml: html,
            Landscape: pl.landscape,
        });
    }

    InitInvoiceData(dbRec, initData) {
        var InvData = null;
        if (dbRec.data) {
            InvData = {
                companydata: dbRec.data.company_data,
                receiver: dbRec.data.consignee,
                buyerimporter: dbRec.data.buyer,
                conditionofdelivery: dbRec.data.condition_of_delivery,
                paymentcondition: dbRec.data.payment_condition,
                bankaccount: dbRec.data.account,
                transportprice: dbRec.data.transport_cost,
                meansoftransport: dbRec.data.means_of_transport,
                dateofshipment: dbRec.data.date_of_shipment,
                placeofshipment: dbRec.data.place_of_shipment,
                //data.letter_of_credit,
                destination: dbRec.data.destination,
                currency: dbRec.data.currency,
                //data.transport_cost,
                vatvalue: dbRec.data.vat_perc,
                //data.bottom_left,
                place: dbRec.data.place,
                date: dbRec.data.date,
            };

            this.setState({ TransportId: dbRec.data.transport });
            // this.state.TransportId = dbRec.data.transport;
        } else InvData = {};
        if (initData) {
            InvData = {
                ...InvData,
                invoicedate: initData.data.invoice_date,
                invoiceno: initData.data.invoice_no,
                hs: initData.data.hs,
                meansoftransport: "Cont. No : " + initData.data.container_no,
            };
        }
        var rows = [];
        if (dbRec.positions)
            for (var i = 0; i < dbRec.positions.length; i++) {
                var rec = dbRec.positions[i];
                var row = {
                    id: rec.id,
                    coli: rec.pack_cnt,
                    description: rec.article_name ? rec.article_name : rec.name,
                    quantity: rec.quantity,
                    price: rec.value || 0,
                };
                rows.push(row);
            }

        this.setState({ InvData: InvData, Rows: rows });
    }

    SaveInvoiceData(dbRec) {
        var data = {
            company_data: this.refs.companydata.GetValue() || "",
            consignee: this.refs.receiver.GetValue() || "",
            buyer: this.refs.buyerimporter.GetValue() || "",
            condition_of_delivery: this.refs.conditionofdelivery.GetValue() || "",
            payment_condition: this.refs.paymentcondition.GetValue() || "",
            account: this.refs.bankaccount.GetValue() || "",
            transport: this.state.TransportId || 0,
            means_of_transport: this.refs.meansoftransport.GetValue() || "",
            date_of_shipment: moment(this.refs.dateofshipment.GetValue()).format("YYYYMMDD"),
            place_of_shipment: this.refs.placeofshipment.GetValue() || "",
            letter_of_credit: "",
            destination: this.refs.destination.GetValue() || "",
            currency: this.refs.currency.GetValue() || "",
            transport_cost: this.transportprice.current.GetValue() || 0,
            vat_perc: this.vatvalue.current.GetValue() || 0,
            bottom_left: "",
            place: this.refs.place.GetValue() || "",
            date: moment(this.refs.date.GetValue()).format("YYYYMMDD"),
        };

        var rows = [];
        for (var i = 0; i < this.state.Rows.length; i++) {
            var rec = this.state.Rows[i];
            var row = {
                pack_cnt: rec.coli,
                article_name: rec.description,
                quantity: rec.quantity,
                value: rec.price || 0,
            };
            rows.push(row);
        }
        var sid = Context.GetContext().Sid;
        Comm.SaveInvoice({
            session: sid,
            packing_list: this.state.DisplayedPackingList,
            data: JSON.stringify(data),
            positions: JSON.stringify(rows),
        });
        this.setState({ PageName: "packinglists" });
    }

    ShowPackingListReport() {
        this.setState({ PageName: "packinglists" }); // made to go back to the packing list reports insteaf of concrete packing list
    }

    RotateColumns(document) {
        var headings = document.getElementsByClassName("vert");
        for (var i = 0; i < headings.length; i++) {
            var h = headings[i];
            var label = h.innerText.trim();
            h.innerHTML = "";
            var canvas = document.createElement("canvas");
            var context = canvas.getContext("2d");
            context.font = h.style.font;
            context.textAlign = "right";
            context.save();
            var metrics = context.measureText(label);
            canvas.height = parseInt(metrics.width, 10);
            canvas.width = context.measureText("M").width; //най-точно приближение
            context.restore();
            context.font = h.style.font;
            //context.fillStyle = "#ff0000"; // red
            context.textAlign = "right";

            // hold top-right hand corner when rotating
            context.translate(canvas.width - 1, 0);
            //context.translate(0, 0);

            context.rotate((3 * Math.PI) / 2);

            context.fillText(label, 0, 0);
            h.appendChild(canvas);
        }
    }

    componentDidUpdate(prevProps, prevState, snapshot) {
        if (this.state.PageName === "packinglist") this.RotateColumns(document);
    }

    PrintElem() {
        var mywindow = window.open("", "PRINT", "height=400,width=600");

        mywindow.document.write("<html><head><title>" + document.title + "</title>");
        mywindow.document.write("<style>@media print {@page {size: landscape}}</style>");
        mywindow.document.write("</head><body >");
        //mywindow.document.write('<h1>' + document.title + '</h1>');
        mywindow.document.write(this.state.PackingListHtml);
        mywindow.document.write("</body></html>");

        mywindow.document.close(); // necessary for IE >= 10
        mywindow.focus(); // necessary for IE >= 10*/
        this.RotateColumns(mywindow.document);
        mywindow.print();
        mywindow.close();

        return true;
    }

    ShowSubPage(page) {
        if (this.state.PageName === "invoice") this.GenerateDataObject();
        this.setState({ PageName: page });
    }

    EditRow(obj) {
        if (obj === null) {
            obj = {
                id: Context.Guid(),
                coli: 0,
                description: "",
                quantity: 0,
                price: 0,
            };
        }
        this.setState({ EditRow: obj });
    }
    DelRow(obj) {
        console.log(obj, "obj");
        var rows = this.state.Rows.slice();
        for (var i = 0; i < rows.length; i++)
            if (rows[i].id === obj.id) {
                rows.splice(i, 1);
                break;
            }

        var totals = this.RecalcTotal(rows);
        this.setState({
            Rows: rows,
            TotalCount: totals.TotalCount,
            WithoutTransport: totals.WithoutTransport,
            Beforevat: totals.Beforevat,
            Aftervat: totals.Aftervat,
        });
    }

    SaveRow() {
        var obj = this.state.EditRow;
        obj.coli = this.refs.rowcoli.GetValue();
        obj.description = this.refs.rowdescription.GetValue();
        obj.quantity = this.refs.rowquantity.GetValue();
        obj.price = this.refs.rowprice.GetValue();
        var rows = this.state.Rows.slice();
        var found = false;
        for (var i = 0; i < rows.length; i++)
            if (rows[i].id === obj.id) {
                rows[i] = obj;
                found = true;
                break;
            }
        if (!found) rows.push(obj);
        var totals = this.RecalcTotal(rows);
        this.setState({
            EditRow: null,
            Rows: rows,
            TotalCount: totals.TotalCount,
            WithoutTransport: totals.WithoutTransport,
            Beforevat: totals.Beforevat,
            Aftervat: totals.Aftervat,
        });
    }
    CancelRow() {
        this.setState({
            EditRow: null,
        });
    }

    RecalcTotal(rows) {
        var transport = parseFloat(this.transportprice.current.GetValue()) || 0;
        var subtotal = transport;
        var totalCount = 0;
        if (!rows) rows = this.state.Rows.slice();
        for (var i = 0; i < rows.length; i++) {
            var item = rows[i];
            totalCount += parseInt(item.coli, 10);
            subtotal += parseFloat(item.price) * parseFloat(item.quantity) * parseFloat(item.coli);
        }
        var av = subtotal + (subtotal * parseFloat(this.vatvalue.current.GetValue())) / 100;
        return {
            WithoutTransport: subtotal - transport,
            TotalCount: totalCount,
            Beforevat: subtotal,
            Aftervat: av,
        };
    }

    DisplayTotals() {
        if (this.state.PageName !== "invoice") return;
        var totals = this.RecalcTotal();
        this.setState({
            WithoutTransport: totals.WithoutTransport,
            TotalCount: totals.TotalCount,

            Beforevat: totals.Beforevat,
            Aftervat: totals.Aftervat,
        });
    }

    GenerateDataObject() {
        var obj = {};
        for (var ref in this.refs) {
            if (ref.includes("date")) {
                if (this.refs[ref].GetValue() === "Invalid date") continue;
                obj[ref] = moment(this.refs[ref].GetValue(), "DD.MM.YYYY").format("YYYYMMDD");
            } else {
                obj[ref] = this.refs[ref].GetValue();
            }
        }
        obj.vatvalue = this.vatvalue.current.GetValue();
        obj.transportprice = this.transportprice.current.GetValue();

        this.setState({ InvData: obj });
    }

    PrintInvoice() {
        var mywindow = window.open("", "PRINT", "height=400,width=600");

        //mywindow.document.write('<html><head><title>' + document.title + '</title>');
        mywindow.document.write("<style>@media print {@page {size: landscape}}</style>");
        mywindow.document.write("</head><body >");
        //mywindow.document.write('<h1>' + document.title + '</h1>');
        mywindow.document.write(document.getElementById("dInvoice").innerHTML);
        mywindow.document.write("</body></html>");

        mywindow.document.close(); // necessary for IE >= 10
        mywindow.focus(); // necessary for IE >= 10*/
        this.RotateColumns(mywindow.document);
        mywindow.print();
        mywindow.close();

        return true;
    }

    render() {
        if (!Comm.ValidSession()) {
            Context.Logout();
            return <Redirect to="/login" push></Redirect>;
        }

        if (Context.RenderNotOK(this.props.history)) return null;
        // var options = ["aaa", "aaa", "aaa", "aaa", "aaa", "aaa", "aaa", "aaa", "aaa", "aaa"]; // not used below
        const disabledInvoiceSave =
            this.state.PageName === "invoice" &&
            this.refs.invoicedate &&
            this.refs.invoicedate.GetValue() === "Invalid date" &&
            this.refs.dateofshipment &&
            this.refs.dateofshipment.GetValue() === "Invalid date" &&
            this.refs.orderdate &&
            this.refs.orderdate.GetValue() === "Invalid date" &&
            this.refs.date &&
            this.refs.date.GetValue() === "Invalid date";
        console.log("state", this.state);
        return Context.HasRight("rinvoices") ? (
            <div className="panel panel-default">
                <div className="panel-heading">{Translation.Trans("invoicesexport")}</div>
                <div className="panel-body">
                    {this.state.PageName === "packinglistdata" ? (
                        <PackinglistData
                            ref="pddata"
                            plid={this.state.DisplayedPackingList}
                            hidepagefunc={this.ShowPackingListReport}
                            updatePackingList={() =>
                                this.ShowPackingList(this.state.DisplayedPackingList, true)
                            }
                        ></PackinglistData>
                    ) : null}
                    {this.state.PageName === "packinglists" ? (
                        <div>
                            <div className="col-md-12">
                                <select
                                    id="ddlPartner"
                                    className="form-control"
                                    onChange={() => this.ChangePartner()}
                                >
                                    {this.state.Partners.map((item) => (
                                        <option key={item.id} value={item.id}>
                                            {item.name}
                                        </option>
                                    ))}
                                </select>
                            </div>
                            <p>&nbsp;</p>
                            <div className="col-md-12">
                                {this.state.PackingLists.packing_lists ? (
                                    <table className="table table-striped">
                                        <tbody>
                                            {this.state.PackingLists.packing_lists.map((item) => (
                                                <tr key={item.id}>
                                                    <td>
                                                        {item.invoice_id ? <span>xxxx</span> : null}
                                                        {item.date}
                                                    </td>
                                                    <td>{item.name}</td>
                                                    <td>
                                                        <button
                                                            type="button"
                                                            className="btn btn-default fullwidth"
                                                            onClick={() => this.ShowPackingList(item.id)}
                                                        >
                                                            {Translation.Trans("show")}
                                                        </button>
                                                    </td>
                                                    <td>
                                                        <i
                                                            className="far fa-trash-alt pointhand"
                                                            onClick={() => this.DeletePackingList(item.id)}
                                                        ></i>
                                                    </td>
                                                </tr>
                                            ))}
                                        </tbody>
                                    </table>
                                ) : null}
                            </div>
                            <div className="col-md-1">
                                {this.state.PackingListsPage > 0 ? (
                                    <button
                                        type="button"
                                        className="btn btn-default fullwidth"
                                        onClick={() => this.ChangePage(-1)}
                                    >
                                        &lt;&lt;
                                    </button>
                                ) : null}
                            </div>
                            <div className="col-md-1">
                                {(this.state.PackingListsPage + 1) * this.PackingListsPageSize <
                                this.state.PackingLists.count ? (
                                    <button
                                        type="button"
                                        className="btn btn-default fullwidth"
                                        onClick={() => this.ChangePage(1)}
                                    >
                                        &gt;&gt;
                                    </button>
                                ) : null}
                            </div>
                        </div>
                    ) : null}
                    {this.state.PageName === "packinglist" ||
                    this.state.PageName === "invoice" ||
                    this.state.PageName === "preview" ? (
                        <div>
                            <div className="col-md-4">
                                <button
                                    type="button"
                                    className={
                                        this.state.PageName === "packinglist"
                                            ? "btn btn-warning fullwidth"
                                            : "btn btn-default fullwidth"
                                    }
                                    onClick={() => this.ShowSubPage("packinglist")}
                                >
                                    {Translation.Trans("packinglist")}
                                </button>
                            </div>
                            <div className="col-md-4">
                                <button
                                    type="button"
                                    className={
                                        this.state.PageName === "invoice"
                                            ? "btn btn-warning fullwidth"
                                            : "btn btn-default fullwidth"
                                    }
                                    onClick={() => this.ShowSubPage("invoice")}
                                >
                                    {Translation.Trans("invoice")}
                                </button>
                            </div>
                            <div className="col-md-4">
                                <button
                                    type="button"
                                    className={
                                        this.state.PageName === "preview"
                                            ? "btn btn-warning fullwidth"
                                            : "btn btn-default fullwidth"
                                    }
                                    onClick={() => this.ShowSubPage("preview")}
                                >
                                    {Translation.Trans("preview")}
                                </button>
                            </div>
                        </div>
                    ) : null}
                    {this.state.PageName === "packinglist" ? (
                        <div>
                            <div
                                className="col-md-12"
                                id="dPackingList"
                                dangerouslySetInnerHTML={{ __html: this.state.PackingListHtml }}
                            ></div>
                            <div className="col-md-12">
                                <button className="btn btn-primary fullwidth" onClick={this.PrintElem}>
                                    <i className="fa fa-print"></i>
                                    <p>{Translation.Trans("print")}</p>
                                </button>
                            </div>
                        </div>
                    ) : null}
                    {this.state.PageName === "invoice" ? (
                        <div>
                            <div className="col-md-6">
                                <label className="control-label">{Translation.Trans("companydata")}</label>
                                <Edit
                                    ref="companydata"
                                    type="textarea"
                                    rows="4"
                                    value={this.state.InvData.companydata || "EORI:"}
                                />
                            </div>
                            <div className="col-md-12">
                                <h3>{Translation.Trans("invoicedata")}</h3>
                            </div>
                            <div className="col-md-6">
                                <label className="control-label">{Translation.Trans("invoiceno")}</label>
                                <Edit ref="invoiceno" type="text" value={this.state.InvData.invoiceno} />
                            </div>
                            <div className="col-md-6">
                                <label className="control-label">{Translation.Trans("invoicedate")}</label>
                                <Edit ref="invoicedate" type="date" value={this.state.InvData.invoicedate} />
                            </div>
                            <div className="col-md-6">
                                <label className="control-label">{Translation.Trans("contractno")}</label>
                                <Edit ref="contractno" type="text" value={this.state.InvData.contractno} />
                            </div>
                            <div className="col-md-6">
                                <label className="control-label">
                                    {Translation.Trans("annextocontractno")}
                                </label>
                                <Edit
                                    ref="annextocontractno"
                                    type="text"
                                    value={this.state.InvData.annextocontractno}
                                />
                            </div>
                            <div className="col-md-6">
                                <label className="control-label">{Translation.Trans("orderno")}</label>
                                <Edit ref="orderno" type="text" value={this.state.InvData.orderno} />
                            </div>
                            <div className="col-md-6">
                                <label className="control-label">{Translation.Trans("orderdate")}</label>
                                <Edit ref="orderdate" type="date" value={this.state.InvData.orderdate} />
                            </div>
                            <div className="col-md-6">
                                <label className="control-label">{Translation.Trans("originofgoods")}</label>
                                <Edit
                                    ref="originofgoods"
                                    type="text"
                                    value={this.state.InvData.originofgoods}
                                />
                            </div>
                            <div className="col-md-6">
                                <label className="control-label">{Translation.Trans("codeofgoods")}</label>
                                <Edit ref="codeofgoods" type="text" value={this.state.InvData.codeofgoods} />
                            </div>
                            <div className="col-md-6">
                                <label className="control-label">{Translation.Trans("sealno")}</label>
                                <Edit ref="sealno" type="text" value={this.state.InvData.sealno} />
                            </div>
                            <div className="col-md-6">
                                <label className="control-label">{Translation.Trans("comno")}</label>
                                <Edit ref="comno" type="text" value={this.state.InvData.comno} />
                            </div>
                            <div className="col-md-6">
                                <label className="control-label">{Translation.Trans("indentno")}</label>
                                <Edit ref="indentno" type="text" value={this.state.InvData.indentno} />
                            </div>
                            <div className="col-md-6">
                                <label className="control-label">{Translation.Trans("bookingno")}</label>
                                <Edit ref="bookingno" type="text" value={this.state.InvData.bookingno} />
                            </div>
                            <div className="col-md-6">
                                <label className="control-label">{Translation.Trans("hs")}</label>
                                <Edit ref="hs" type="text" value={this.state.InvData.hs} />
                            </div>
                            <div className="col-md-12"></div>
                            <div className="col-md-6">
                                <label className="control-label">{Translation.Trans("buyerimporter")}</label>

                                <select
                                    id="ddlContragent"
                                    className="form-control"
                                    onChange={(e) => this.ChangeBuyer(e)}
                                >
                                    {this.state.Buyers.map((item) => (
                                        <option key={item.id} value={JSON.stringify(item)}>
                                            {item.name}
                                        </option>
                                    ))}
                                </select>
                            </div>
                            <div className="col-md-6">
                                <label className="control-label">{Translation.Trans("buyerimporter")}</label>
                                <Edit
                                    ref="buyerimporter"
                                    type="textarea"
                                    rows="4"
                                    value={this.state.InvData.buyerimporter}
                                />
                            </div>
                            <div className="col-md-6">
                                <label className="control-label">{Translation.Trans("receiver")}</label>

                                <select
                                    id="ddlReceiver"
                                    className="form-control"
                                    onChange={(e) => this.ChangeReceiver(e)}
                                >
                                    {this.state.Receivers.map((item, idx) => (
                                        <option key={idx} value={JSON.stringify(item)}>
                                            {item.name}
                                        </option>
                                    ))}
                                </select>
                                <button
                                    type="button"
                                    className="btn btn-default"
                                    onClick={() => this.CopyAddressFromBuyer()}
                                >
                                    {Translation.Trans("usepartnerdata")}
                                </button>
                            </div>
                            <div className="col-md-6">
                                <label className="control-label">{Translation.Trans("receiver")}</label>
                                <Edit
                                    ref="receiver"
                                    type="textarea"
                                    rows="4"
                                    value={this.state.InvData.receiver}
                                />
                            </div>
                            <div className="col-md-6">
                                <label className="control-label">
                                    {Translation.Trans("conditionofdelivery")}
                                </label>
                                <Edit
                                    ref="conditionofdelivery"
                                    type="dropdown"
                                    value={this.state.InvData.conditionofdelivery}
                                    options={this.state.ConditionsOfDelivery || []}
                                />
                            </div>
                            <div className="col-md-6">
                                <label className="control-label">
                                    {Translation.Trans("paymentcondition")}
                                </label>
                                <Edit
                                    ref="paymentcondition"
                                    type="dropdown"
                                    value={this.state.InvData.paymentcondition}
                                    options={this.state.PaymentConditions || []}
                                />
                            </div>
                            <div className="col-md-12">
                                <label className="control-label">{Translation.Trans("account")}</label>
                                <Edit
                                    ref="bankaccount"
                                    type="dropdown"
                                    value={this.state.InvData.bankaccount}
                                    options={this.state.Accounts}
                                />
                            </div>
                            <div className="col-md-6">
                                <label className="control-label">{Translation.Trans("transport")}</label>
                                <select
                                    className="form-control"
                                    onChange={(e) => this.ChangeTransport(e)}
                                    defaultValue={this.state.InvData.transportby}
                                >
                                    <option value="1">{Translation.Trans("bysea")}</option>
                                    <option value="2">{Translation.Trans("other")}</option>
                                </select>
                            </div>
                            <div className="col-md-6">
                                <label className="control-label">
                                    {Translation.Trans("meansoftransport")}
                                </label>
                                <Edit
                                    ref="meansoftransport"
                                    type="textarea"
                                    rows="4"
                                    value={this.state.InvData.meansoftransport || "Cont. No : "}
                                />
                            </div>
                            <div className="col-md-6">
                                <label className="control-label">{Translation.Trans("dateofshipment")}</label>
                                <Edit
                                    ref="dateofshipment"
                                    type="date"
                                    value={this.state.InvData.dateofshipment}
                                />
                            </div>
                            <div className="col-md-6">
                                <label className="control-label">
                                    {Translation.Trans("placeofshipment")}
                                </label>
                                <Edit
                                    ref="placeofshipment"
                                    type="dropdown"
                                    value={this.state.InvData.placeofshipment}
                                    options={this.state.PlacesOfShipment || []}
                                />
                            </div>
                            <div className="col-md-6">
                                <label className="control-label">{Translation.Trans("destination")}</label>
                                <Edit ref="destination" type="text" value={this.state.InvData.destination} />
                            </div>
                            <div className="col-md-6">
                                <label className="control-label">{Translation.Trans("currency")}</label>
                                <Edit ref="currency" type="text" value={this.state.InvData.currency} />
                            </div>
                            <div className="col-md-12">
                                <label className="control-label">{Translation.Trans("summary")}</label>
                                <Edit ref="summary" type="text" value={this.state.InvData.summary} />
                            </div>
                            <div className="col-md-12">
                                <button
                                    type="button"
                                    className="btn btn-default"
                                    onClick={() => this.EditRow(null)}
                                >
                                    {Translation.Trans("newrow")}
                                </button>
                                <table className="table table-striped">
                                    <thead>
                                        <tr>
                                            <th>{Translation.Trans("invoicecolli")}</th>
                                            <th>{Translation.Trans("invoicedescription")}</th>
                                            <th>{Translation.Trans("invoicequantity")}</th>
                                            <th>{Translation.Trans("invoiceunitprice")}</th>
                                            <th>{Translation.Trans("invoicevalue")}</th>
                                            <th></th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {!this.state.EditRow ? (
                                            this.state.Rows.map((item, idx) => (
                                                <tr key={idx}>
                                                    <td>{item.coli}</td>
                                                    <td>{item.description}</td>
                                                    <td>{item.quantity}</td>
                                                    <td>{item.price}</td>
                                                    <td>{item.price * item.quantity * item.coli}</td>
                                                    <td>
                                                        <i
                                                            className="fas fa-edit"
                                                            onClick={() => this.EditRow(item)}
                                                        ></i>
                                                        <i
                                                            className="fas fa-times-circle"
                                                            onClick={() => this.DelRow(item)}
                                                        ></i>
                                                    </td>
                                                </tr>
                                            ))
                                        ) : (
                                            <tr>
                                                <td>
                                                    <Edit
                                                        ref="rowcoli"
                                                        type="text"
                                                        value={this.state.EditRow.coli}
                                                        datatype="int"
                                                    />
                                                </td>
                                                <td>
                                                    <Edit
                                                        ref="rowdescription"
                                                        type="text"
                                                        value={this.state.EditRow.description}
                                                    />
                                                </td>
                                                <td>
                                                    <Edit
                                                        ref="rowquantity"
                                                        type="text"
                                                        value={this.state.EditRow.quantity}
                                                        datatype="decimal"
                                                    />
                                                </td>
                                                <td>
                                                    <Edit
                                                        ref="rowprice"
                                                        type="text"
                                                        value={this.state.EditRow.price}
                                                        datatype="decimal"
                                                    />
                                                </td>
                                                <td></td>
                                                <td>
                                                    <i
                                                        className="fas fa-save"
                                                        onClick={() => this.SaveRow()}
                                                    ></i>
                                                    <i
                                                        className="fas fa-ban"
                                                        onClick={() => this.CancelRow()}
                                                    ></i>
                                                </td>
                                            </tr>
                                        )}
                                    </tbody>
                                </table>
                            </div>
                            <div className="col-md-6">
                                <label className="control-label">{Translation.Trans("transporttitle")}</label>
                                <Edit
                                    ref="transporttitle"
                                    type="text"
                                    value={this.state.InvData.transporttitle || "transport"}
                                />
                            </div>
                            <div className="col-md-6">
                                <label className="control-label">{Translation.Trans("transportprice")}</label>
                                <Edit
                                    ref={this.transportprice}
                                    type="text"
                                    value={this.state.InvData.transportprice || 0}
                                    datatype="decimal"
                                />
                            </div>
                            <div className="col-md-12">
                                <span className="pull-right">{this.state.Beforevat}</span>
                            </div>
                            <div className="col-md-6"></div>
                            <div className="col-md-6">
                                <label className="control-label">{Translation.Trans("vatvalue")}</label>
                                <Edit
                                    ref={this.vatvalue}
                                    type="text"
                                    value={this.state.InvData.vatvalue || 0}
                                    datatype="decimal"
                                />
                            </div>
                            <div className="col-md-12">
                                <span className="pull-right">
                                    {Translation.Trans("total") + ":" + this.state.Aftervat}
                                </span>
                            </div>
                            <div className="col-md-6"></div>
                            <div className="col-md-6">
                                <label className="control-label">{Translation.Trans("place")}</label>
                                <Edit ref="place" type="text" value={this.state.InvData.place} />
                            </div>
                            <div className="col-md-6"></div>
                            <div className="col-md-6">
                                <label className="control-label">{Translation.Trans("date")}</label>
                                <Edit ref="date" type="date" value={this.state.InvData.date} />
                            </div>

                            <div className="col-md-12">
                                <button
                                    className="btn btn-primary fullwidth"
                                    onClick={() => this.SaveInvoiceData()}
                                    disabled={disabledInvoiceSave || this.state.EditRow}
                                >
                                    <i className="fas fa-save"></i>
                                    <p>{Translation.Trans("save")}</p>
                                </button>
                            </div>
                        </div>
                    ) : null}
                    {this.state.PageName === "preview" ? (
                        <div>
                            <div className="col-md-12" id="dInvoice">
                                <p style={{ textAlign: "center" }}>{Translation.Trans("invoice")}</p>
                                <table className="table-blackbordered" width="100%">
                                    <tbody>
                                        <tr>
                                            <td
                                                colSpan="5"
                                                dangerouslySetInnerHTML={{
                                                    __html: this.state.InvData.companydata
                                                        ? this.state.InvData.companydata.replace(
                                                              /\n/g,
                                                              "<br />"
                                                          )
                                                        : "",
                                                }}
                                            ></td>
                                            <td colSpan="5">
                                                {this.state.InvData.invoiceno ? (
                                                    <p>
                                                        {Translation.Trans("invoiceno") +
                                                            ":" +
                                                            this.state.InvData.invoiceno}
                                                    </p>
                                                ) : null}
                                                {this.state.InvData.invoicedate ? (
                                                    <p>
                                                        {Translation.Trans("invoicedate") +
                                                            ":" +
                                                            moment(this.state.InvData.invoicedate).format(
                                                                "DD.MM.YYYY"
                                                            )}
                                                    </p>
                                                ) : null}
                                                {this.state.InvData.annextocontractno ? (
                                                    <p>
                                                        {Translation.Trans("annextocontractno") +
                                                            ":" +
                                                            this.state.InvData.annextocontractno}
                                                    </p>
                                                ) : null}
                                                {this.state.InvData.orderno ? (
                                                    <p>
                                                        {Translation.Trans("orderno") +
                                                            ":" +
                                                            this.state.InvData.orderno}
                                                    </p>
                                                ) : null}
                                                {this.state.InvData.orderdate ? (
                                                    <p>
                                                        {Translation.Trans("orderdate") +
                                                            ":" +
                                                            moment(this.state.InvData.orderdate).format(
                                                                "DD.MM.YYYY"
                                                            )}
                                                    </p>
                                                ) : null}
                                                {this.state.InvData.originofgoods ? (
                                                    <p>
                                                        {Translation.Trans("originofgoods") +
                                                            ":" +
                                                            this.state.InvData.originofgoods}
                                                    </p>
                                                ) : null}
                                                {this.state.InvData.codeofgoods ? (
                                                    <p>
                                                        {Translation.Trans("codeofgoods") +
                                                            ":" +
                                                            this.state.InvData.codeofgoods}
                                                    </p>
                                                ) : null}
                                                {this.state.InvData.sealno ? (
                                                    <p>
                                                        {Translation.Trans("sealno") +
                                                            ":" +
                                                            this.state.InvData.sealno}
                                                    </p>
                                                ) : null}
                                                {this.state.InvData.comno ? (
                                                    <p>
                                                        {Translation.Trans("comno") +
                                                            ":" +
                                                            this.state.InvData.comno}
                                                    </p>
                                                ) : null}
                                                {this.state.InvData.indentno ? (
                                                    <p>
                                                        {Translation.Trans("indentno") +
                                                            ":" +
                                                            this.state.InvData.indentno}
                                                    </p>
                                                ) : null}
                                                {this.state.InvData.bookingno ? (
                                                    <p>
                                                        {Translation.Trans("bookingno") +
                                                            ":" +
                                                            this.state.InvData.bookingno}
                                                    </p>
                                                ) : null}
                                                {this.state.InvData.hs ? (
                                                    <p>
                                                        {Translation.Trans("hs") +
                                                            ":" +
                                                            this.state.InvData.hs}
                                                    </p>
                                                ) : null}
                                            </td>
                                        </tr>
                                        <tr>
                                            <td colSpan="5">
                                                {Translation.Trans("receiver")}
                                                <br />
                                                {this.state.InvData.receiver ? (
                                                    <p
                                                        dangerouslySetInnerHTML={{
                                                            __html: this.state.InvData.receiver.replace(
                                                                /\n/g,
                                                                "<br />"
                                                            ),
                                                        }}
                                                    ></p>
                                                ) : null}
                                            </td>
                                            <td colSpan="5">
                                                {Translation.Trans("buyerimporter")}
                                                <br />
                                                {this.state.InvData.buyerimporter ? (
                                                    <p
                                                        dangerouslySetInnerHTML={{
                                                            __html: this.state.InvData.buyerimporter.replace(
                                                                /\n/g,
                                                                "<br />"
                                                            ),
                                                        }}
                                                    ></p>
                                                ) : null}
                                            </td>
                                        </tr>
                                        <tr>
                                            <td colSpan="5">
                                                {Translation.Trans("conditionofdelivery")}
                                                <br />
                                                {this.state.InvData.conditionofdelivery}
                                            </td>
                                            <td colSpan="5">
                                                {Translation.Trans("paymentcondition")}
                                                <br />
                                                {this.state.InvData.paymentcondition}
                                                <br />
                                                {this.state.InvData.bankaccount}
                                                <br />
                                            </td>
                                        </tr>
                                        <tr>
                                            <td colSpan="2">
                                                {Translation.Trans("transport")}
                                                <br />
                                                {this.state.InvData.transportby === "1" ? (
                                                    <span>{Translation.Trans("bysea")}</span>
                                                ) : (
                                                    <span>{Translation.Trans("other")}</span>
                                                )}
                                            </td>
                                            <td colSpan="2">
                                                {Translation.Trans("meansoftransport")}
                                                <br />
                                                {this.state.InvData.meansoftransport}
                                            </td>
                                            <td colSpan="2">
                                                {Translation.Trans("contractno")}
                                                <br />
                                                {this.state.InvData.contractno}
                                            </td>
                                            <td colSpan="2">
                                                {Translation.Trans("dateofshipment")}
                                                <br />
                                                {moment(this.state.InvData.dateofshipment).format(
                                                    "DD.MM.YYYY"
                                                )}
                                            </td>
                                            <td colSpan="2">
                                                {Translation.Trans("placeofshipment")}
                                                <br />
                                                {this.state.InvData.placeofshipment}
                                            </td>
                                        </tr>
                                        <tr>
                                            <td colSpan="5">
                                                {Translation.Trans("destination")}
                                                <br />
                                                {this.state.InvData.destination}
                                            </td>
                                            <td colSpan="5">
                                                {Translation.Trans("currency")}
                                                <br />
                                                {this.state.InvData.currency}
                                            </td>
                                        </tr>
                                    </tbody>
                                </table>
                                <table className="table-blackbordered" width="100%">
                                    <thead>
                                        <tr>
                                            <th width="15%">{Translation.Trans("invoicecolli")}</th>
                                            <th width="40%">{Translation.Trans("invoicedescription")}</th>
                                            <th width="15%">{Translation.Trans("invoicequantity")}</th>
                                            <th width="15%">{Translation.Trans("invoiceunitprice")}</th>
                                            <th width="15%">{Translation.Trans("invoicevalue")}</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {this.state.InvData.summary && this.state.InvData.summary !== "" ? (
                                            <tr>
                                                <td width="15%">
                                                    <b>{this.state.TotalCount}</b>
                                                </td>
                                                <td width="40%">{this.state.InvData.summary}</td>
                                                <td width="15%"></td>
                                                <td width="15%"></td>
                                                <td width="15%">
                                                    <b>{this.state.WithoutTransport}</b>
                                                </td>
                                            </tr>
                                        ) : (
                                            this.state.Rows.map((item, idx) => (
                                                <tr key={idx}>
                                                    <td>{item.coli}</td>
                                                    <td>{item.description}</td>
                                                    <td>{item.quantity}</td>
                                                    <td>{item.price}</td>
                                                    <td>{item.price * item.quantity * item.coli}</td>
                                                </tr>
                                            ))
                                        )}
                                    </tbody>
                                </table>
                                <table className="table-nobordered" width="100%">
                                    <tbody>
                                        {this.state.InvData.summary &&
                                        this.state.InvData.summary !== "" ? null : (
                                            <tr>
                                                <td width="15%">
                                                    <b>{this.state.TotalCount}</b>
                                                </td>
                                                <td width="40%"></td>
                                                <td width="15%"></td>
                                                <td width="15%"></td>
                                                <td width="15%">
                                                    <b>{this.state.WithoutTransport}</b>
                                                </td>
                                            </tr>
                                        )}

                                        <tr>
                                            <td width="15%"></td>
                                            <td width="40%">{this.state.InvData.transporttitle}</td>
                                            <td width="15%"></td>
                                            <td width="15%"></td>
                                            <td width="15%">{this.state.InvData.transportprice}</td>
                                        </tr>
                                        <tr>
                                            <td colSpan="3"></td>
                                            <td colSpan="2">
                                                <hr />
                                            </td>
                                        </tr>
                                        <tr>
                                            <td width="15%"></td>
                                            <td width="40%"></td>
                                            <td width="15%"></td>
                                            <td width="15%"></td>
                                            <td width="15%">{this.state.Beforevat}</td>
                                        </tr>
                                        <tr>
                                            <td width="15%"></td>
                                            <td width="40%"></td>
                                            <td width="15%"></td>
                                            <td width="15%">{Translation.Trans("vatvalue") + "(%)"}</td>
                                            <td width="15%">{this.state.InvData.vatvalue}</td>
                                        </tr>
                                        <tr>
                                            <td width="15%"></td>
                                            <td width="40%"></td>
                                            <td width="15%"></td>
                                            <td width="15%">
                                                <b>{Translation.Trans("total")}</b>
                                            </td>
                                            <td width="15%">{this.state.Aftervat}</td>
                                        </tr>
                                    </tbody>
                                </table>
                                <p>&nbsp;</p>
                                <p>&nbsp;</p>
                                <p style={{ textAlign: "right" }}>
                                    {Translation.Trans("place") +
                                        ": " +
                                        this.state.InvData.place +
                                        " " +
                                        Translation.Trans("date") +
                                        ": " +
                                        moment(this.state.InvData.date).format("DD.MM.YYYY")}
                                </p>
                            </div>
                            <div className="col-md-12">
                                <button className="btn btn-primary" onClick={this.PrintInvoice}>
                                    <i className="fa fa-print"></i>
                                    <p>{Translation.Trans("print")}</p>
                                </button>
                            </div>
                        </div>
                    ) : null}
                </div>
            </div>
        ) : (
            <div>{Translation.Trans("noRights")}</div>
        );
    }
}

export default Invoices;



// WEBPACK FOOTER //
// ./src/pages/invoices.js